import NotifyProvider from "./NotifyContext";
import PageProvider from "./GenContext";
import { SplashScreenProvider } from "../components/core";

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <SplashScreenProvider>
      <PageProvider>
        <NotifyProvider>{children}</NotifyProvider>
      </PageProvider>
    </SplashScreenProvider>
  );
};

export default Providers;
